import * as React from 'react';
import { BaseForm } from './Base';
import theme from '../../utils/theme';

const base = (props: any) => {
  const opacity = props.disabled ? 'o-50' : 'o-100';

  return `${theme.form.field.input} ${opacity}`;
};

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export interface TextProps extends InputProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
  className?: string;
}

export const Text = ({
  label,
  id,
  tooltip,
  field,
  type,
  onValueChange,
  className = '',
  ...rest
}: TextProps) => (
  <BaseForm label={label} id={id} tooltip={tooltip} className={className}>
    <input
      className={base(rest)}
      id={id}
      type="text"
      onChange={(e) => onValueChange(field, e.target.value)}
      {...rest}
    />
  </BaseForm>
);
